
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { api } from "../../services/api";
import { Candidato } from "../../types/Candidato";
import { FormCurriculo } from "../FormCurriculo";
import styles from './styles.module.scss'

const MySwal = withReactContent(Swal)

interface ContentProps {
  candidato: Candidato;
}

interface OnSubmitProps {
  candidato: Candidato;
  curriculo: File;
}

interface ResponseProps {
  msg: string;
  success: string;
}

export function Content({ candidato }: ContentProps) {

  async function onSubmitQueroMeCandidatar({ candidato, curriculo }: OnSubmitProps) {
    MySwal.showLoading()

    try {
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      const uniq = urlParams.get('uniq')
      const formData = new FormData()

      formData.append('cpf', candidato.cpf)
      formData.append('telefone', candidato.telefone)
      formData.append('departamento', candidato.departamento)
      formData.append('anexo', curriculo)
      formData.append('uniq', uniq)
      

      const { data } = await api.post<ResponseProps>('/curriculo', formData, { headers: { 'content-type': 'multipart/form-data' } })

      exibeMensagem(data)
    } catch (err) {
      exibeMensagem({ success: 'false', msg: 'Ocorreu um erro ao tentar enviar os dados ao servidor!' })
    }
  }

  async function exibeMensagem({ success, msg }: ResponseProps) {
    if (success === 'true') {

      await MySwal.fire({
        icon: 'success',
        title: msg,
        showConfirmButton: false,
        timer: 2500,
        customClass: {
          confirmButton: 'confirmButtonSuccessSweetAlert'
        }
      })

      return
    }

    await MySwal.fire({
      icon: 'error',
      text: msg,
      customClass: {
        confirmButton: 'confirmButtonErrorSweetAlert'
      }
    })

  }

  if (candidato.success === 'true') {
    return (
      <>
        <div className={styles.content}>
          <h2> Olá {candidato?.nome ?? 'Candidato'} </h2>
          <h1>
            Você foi indicado para uma vaga da Bellinati Perez
          </h1>
          <p>
            Para continuar com o processo seletivo, precisamos que você confirme algumas informações
          </p>
        </div>

        <FormCurriculo candidato={candidato} onSubmit={onSubmitQueroMeCandidatar} />
      </>
    )
  }

  return (
    <div className={styles.content}>
      <h1>
        {candidato.msg}
      </h1>
    </div>
  )
}